import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import NProgress from "nprogress"; // 加载条
import "nprogress/nprogress.css"; // 加载条样式
import Cookie from "js-cookie";
import userService from "@/global/service/user";
import Store from "@/store/index";
Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  routes
});
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
router.firstInit = false;
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const TOKEN = Cookie.get("shiguang_token");
  if (to.name !== "login" && !TOKEN) {
    return next({ name: "login" });
  }
  if (to.name === "login" && TOKEN) {
    return next({ name: "home" });
  }
  if (!router.firstInit && TOKEN) {
    router.firstInit = true;
    const userInfo = await userService.userInfo();
    Store.commit("setUserInfo", userInfo);
  }
  next();
});

// eslint-disable-next-line
router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
